export const config = {
  isRootTemplate: true,
  bilingualEnabled: true,
  number: "0000000",
  viewPrioritize: "sellerSection",
  style: {
    color: "rgba(0, 0, 0, 1)",
    fontFamily: "Time New Roman",
    fontSize: "13px",
    fontWeight: "normal",
    fontStyle: "normal",
    textDecoration: "none",
    lineHeight: null,
    letterSpacing: null,
  },
  qrCode: {
    enabled: true,
    url: `${location.origin}/images/qrcode.svg`,
    style: {
      width: "80px",
    },
  },
  logo: {
    enabled: true,
    url: `${location.origin}/images/lcs-logo.png`,
    style: {
      width: "120px",
    },
  },
  watermark: {
    useLogo: true,
    enabled: true,
    url: `${location.origin}/images/lcs-logo.png`,
    style: {
      transform: "translate(0px, 0px)",
      width: "350px",
      opacity: "0.3",
    },
  },
  background: {
    enabled: false,
    source: "upload", // "library"
    url: `${location.origin}/images/invoice-backgrounds/1.png`,
    style: {
      transform: "translate(0px, 0px)",
      width: "500px",
      opacity: "0.2",
    },
  },
  frame: {
    enabled: true,
    type: "pattern", // "pattern", // "border",
    padding: "4",
    border: {
      style: {
        borderStyle: "solid",
        borderWidth: "2px",
        borderColor: "rgba(9, 121, 233, .7)",
      },
    },
    pattern: {
      style: {
        opacity: "0.5",
      },
      patternCategory: "màu xanh dương",
      patternName: "pattern-001",
      url: `${location.origin}/invoice-frames/01.png`,
    },
  },
  invoiceSection: {
    isSelectable: true,
    canAddCustomField: false,
    logoWidth: "20%",
    headingStyle: {
      textAlign: "center",
      verticalAlign: "middle",
    },
    headingFieldWidth: "50%",
    fields: [
      {
        visible: true,
        editable: true,
        canHide: true,
        arrangeable: false,
        order: 1,
        defaultValue: "",
        showDefaultValue: true,
        style: {
          width: "50%",
        },
        valueStyle: {},
        labelStyle: {
          vi: {
            textTransform: "uppercase",
            color: "rgba(255, 0, 0, 1)",
            fontWeight: "bold",
            fontSize: "18px",
          },
          en: {
            textTransform: "uppercase",
            fontSize: "16px",
            fontWeight: "400",
            fontStyle: "italic",
          },
        },
        label: {
          vi: "HÓA ĐƠN GIÁ TRỊ GIA TĂNG",
          en: "(VAT INVOICE)",
        },
      },
      {
        visible: true,
        editable: true,
        canHide: true,
        arrangeable: false,
        order: 2,
        visibleOnInvoiceForm: "Conversion",
        defaultValue: "",
        showDefaultValue: true,
        valueStyle: {},
        labelStyle: {
          vi: {
            textTransform: "uppercase",
            fontSize: "14px",
          },
          en: {},
        },
        label: {
          vi: "Hóa đơn chuyển đổi từ hóa đơn điện tử",
        },
      },
    ],
    serialNo: {
      visible: true,
      editable: false,
      hasValue: true,
      canHide: false,
      arrangeable: false,
      order: 2,
      defaultValue: "",
      showDefaultValue: true,
      style: {
        width: "50%",
      },
      name: "serial_no",
      delimiterStyle: {},
      delimiter: ":",
      type: "1",
      prefix: "C22T",
      value: "AA",
      valueStyle: {
        fontWeight: "bold",
        fontSize: "16px",
      },
      labelStyle: {
        vi: {
          fontSize: "14px",
        },
        en: {
          fontStyle: "italic",
          fontSize: "13px",
        },
      },
      label: {
        vi: "Ký hiệu",
        en: "(Serial No)",
      },
    },
    no: {
      visible: true,
      editable: false,
      hasValue: true,
      canHide: false,
      arrangeable: false,
      order: 2,
      defaultValue: "",
      showDefaultValue: true,
      style: {
        width: "50%",
      },
      delimiterStyle: {},
      delimiter: ":",
      name: "invoice_no",
      value: "0000000",
      valueStyle: {
        color: "rgba(255, 0, 0, 1)",
        letterSpacing: 1,
        fontWeight: "bold",
        fontSize: "16px",
      },
      labelStyle: {
        vi: {
          fontSize: "14px",
        },
        en: {
          fontStyle: "italic",
          fontSize: "13px",
        },
      },
      label: {
        vi: "Số",
        en: "(No.)",
      },
    },
    dateTime: {
      visible: true,
      editable: false,
      canHide: false,
      arrangeable: false,
      order: 2,
      defaultValue: "",
      showDefaultValue: true,
      style: {
        width: "50%",
      },
      valueStyle: {},
      labelStyle: {
        vi: {
          display: "inline-block",
          fontSize: "14px",
        },
        en: {
          display: "inline-block",
          fontStyle: "italic",
          fontSize: "13px",
        },
      },
      label: {
        vi: "ngày tháng năm",
        en: "(day) (month) (year)",
      },
    },
  },
  customerSection: {
    isSelectable: true,
    canAddCustomField: true,
    border: {
      enabled: true,
    },
    fields: [
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 1,
        name: "buyer_name",
        defaultValue: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold" },
          en: { fontSize: "13px", fontStyle: "italic" },
        },
        label: {
          vi: "Họ tên người mua hàng",
          en: "(Buyer's fullname)",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 2,
        name: "buyer_company_name",
        defaultValue: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold" },
          en: { fontSize: "13px", fontStyle: "italic" },
        },
        label: {
          vi: "Tên đơn vị",
          en: "(Company name)",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 3,
        name: "buyer_address",
        defaultValue: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold" },
          en: { fontSize: "13px", fontStyle: "italic" },
        },
        label: {
          vi: "Địa chỉ",
          en: "(Address)",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 4,
        name: "buyer_tax_code",
        defaultValue: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold" },
          en: { fontSize: "13px", fontStyle: "italic" },
        },
        label: {
          vi: "Mã số thuế",
          en: "(Tax code)",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 5,
        name: "buyer_tel_number",
        defaultValue: "",
        style: {
          width: "50%",
          display: "inline-flex",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold", flexShrink: 0 },
          en: { fontSize: "13px", fontStyle: "italic", flexShrink: 0 },
        },
        label: {
          vi: "Số điện thoại",
          en: "Tel",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 6,
        name: "buyer_email",
        defaultValue: "",
        style: {
          width: "50%",
          display: "inline-flex",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold", flexShrink: 0 },
          en: { fontSize: "13px", fontStyle: "italic", flexShrink: 0 },
        },
        label: {
          vi: "Email",
          en: "",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 7,
        name: "buyer_payment_method",
        defaultValue: "",
        style: {
          width: "50%",
          display: "inline-flex",
        },
        delimiterStyle: {},
        delimiter: ":",
        value: "Chuyển khoản ngân hàng",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold", flexShrink: 0 },
          en: { fontSize: "13px", fontStyle: "italic", flexShrink: 0 },
        },
        label: {
          vi: "Hình thức thanh toán",
          en: "(Payment method)",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 8,
        name: "buyer_account_number",
        defaultValue: "",
        style: {
          width: "50%",
          display: "inline-flex",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: { fontSize: "14px" },
        labelStyle: {
          vi: { fontSize: "14px", fontWeight: "bold", flexShrink: 0 },
          en: { fontSize: "13px", fontStyle: "italic", flexShrink: 0 },
        },
        label: {
          vi: "Số tài khoản",
          en: "(A/C No)",
        },
      },
    ],
  },
  sellerSection: {
    isSelectable: true,
    canAddCustomField: true,
    fields: [
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 1,
        name: "seller_name",
        value: "",
        defaultValue: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: {
          color: "rgba(255, 0, 0, 1)",
          fontWeight: "bold",
          fontSize: "14px",
        },
        label: {
          vi: "Đơn vị bán hàng",
          en: "(Seller)",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 2,
        name: "seller_tax_code",
        defaultValue: "",
        value: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: {
          fontWeight: "bold",
          fontSize: "14px",
        },
        label: {
          vi: "Mã số thuế",
          en: "(Tax code)",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 3,
        name: "seller_address",
        value: "",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: {
          fontSize: "14px",
        },
        label: {
          vi: "Địa chỉ",
          en: "(Address)",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 4,
        name: "seller_tel",
        value: "0978436843",
        defaultValue: "",
        style: {
          width: "50%",
          display: "inline-block",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: {
          fontSize: "14px",
        },
        label: {
          vi: "Điện thoại",
          en: "(Tel)",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 5,
        style: {
          width: "50%",
          display: "inline-block",
        },
        delimiterStyle: {},
        delimiter: ":",
        name: "seller_email",
        value: "",
        defaultValue: "",
        valueStyle: {
          fontSize: "14px",
        },
        label: {
          vi: "Email",
          en: "",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 5,
        dataType: "number",
        style: {
          width: "50%",
          display: "inline-block",
        },
        delimiterStyle: {},
        delimiter: ":",
        name: "seller_fax",
        value: "",
        defaultValue: "",
        valueStyle: {
          fontSize: "14px",
        },
        label: {
          vi: "Fax",
          en: "",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 5,
        name: "seller_website",
        value: "https://inv.4si.vn",
        defaultValue: "",
        style: {
          width: "50%",
          display: "inline-block",
        },
        delimiterStyle: {},
        delimiter: ":",
        valueStyle: {
          fontSize: "14px",
        },
        label: {
          vi: "Website",
          en: "(A/C No)",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
      {
        editable: true,
        visible: true,
        canHide: true,
        hasValue: true,
        arrangeable: true,
        order: 5,
        dataType: "number",
        style: {
          width: "100%",
        },
        delimiterStyle: {},
        delimiter: ":",
        name: "seller_account_number",
        value: "",
        defaultValue: "",
        valueStyle: {
          fontSize: "14px",
        },
        label: {
          vi: "Số tài khoản",
          en: "(A/C No)",
        },
        labelStyle: {
          vi: {
            fontWeight: "bold",
            fontSize: "14px",
          },
          en: {
            fontStyle: "italic",
            fontSize: "13px",
          },
        },
      },
    ],
  },
  invoiceTableSection: {
    isSelectable: true,
    numberOfLines: 8,
    border: {
      enabled: true,
      style: {
        borderTopWidth: "1px",
        borderStyle: "dashed",
      },
    },
    tableStyle: {
      width: "100%",
      border: "1px solid",
    },
    tableHeadStyle: {
      border: "1px solid",
    },
    summaryRowStyle: {
      borderTop: "1px solid",
    },
    cellStyle: {
      height: "22px",
      borderLeft: "1px solid",
      borderRight: "1px solid",
    },
    hasNumberSymbol: false,
    canAddCustomField: false,
    fields: [
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "5%",
        },
        name: "stt",
        valueStyle: {},
        label: {
          vi: "STT",
          en: "(No.)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
          },
          textAlign: "center",
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(1)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "30%",
        },
        name: "thhdvu",
        valueStyle: {},
        label: {
          vi: "Tên hàng hóa, dịch vụ",
          en: "(Description)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(2)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "dvtinh",
        valueStyle: {},
        label: {
          vi: "Đơn vị tính",
          en: "(Unit)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(3)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "8%",
        },
        name: "sluong",
        valueStyle: {},
        label: {
          vi: "Số lượng",
          en: "(Quantity)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(4)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "dgia",
        valueStyle: {},
        label: {
          vi: "Đơn giá",
          en: "(Unit price)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "thtien",
        valueStyle: {},
        label: {
          vi: "Thành tiền",
          en: "(Amount)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(6)= (4) x (5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
    ],
    summaryFields: [
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          width: "5%",
        },
        colSpan: 5,
        name: "table_total_amount",
        valueStyle: {},
        label: {
          vi: "Cộng tiền hàng",
          en: "(Total amount)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          width: "5%",
        },
        colSpan: 5,
        name: "table_vat_rate",
        valueStyle: {},
        label: {
          vi: "Thuế suất GTGT",
          en: "(VAT Rate)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          width: "5%",
        },
        colSpan: 5,
        valueStyle: {},
        name: "table_vat_amount",
        label: {
          vi: "Tiền thuế GTGT",
          en: "(VAT amount)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          width: "5%",
        },
        colSpan: 5,
        valueStyle: {},
        name: "table_total_payment",
        label: {
          vi: "Tổng cộng tiền thanh toán",
          en: "(Total payment)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          width: "5%",
        },
        colSpan: 5,
        valueStyle: {},
        name: "table_total_in_words",
        label: {
          vi: "Số tiền viết bằng chữ",
          en: "(In words)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
    ],
  },
  summarySection: {},
  signatureSection: {
    isSelectable: true,
    boss: {
      enabled: true,
    },
    fields: [
      {
        name: "converter_sign",
        visibleOnInvoiceForm: "Conversion",
        labels: [
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "Người chuyển đổi",
              en: "(Converter)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontWeight: "bold",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "(Ký, ghi rõ họ tên)",
              en: "(Sign & Fullname)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontStyle: "italic",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
        ],
      },
      {
        name: "buyer_sign",
        labels: [
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "Người mua hàng",
              en: "(Buyer)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontWeight: "bold",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "(Ký, ghi rõ họ tên)",
              en: "(Sign & Fullname)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontStyle: "italic",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
        ],
      },
      {
        name: "seller_sign",
        labels: [
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "Người bán hàng",
              en: "(Seller)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontWeight: "bold",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "(Ký, ghi rõ họ tên)",
              en: "(Sign & Fullname)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontStyle: "italic",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
        ],
      },
      {
        isBossSign: true,
        name: "boss_sign",
        labels: [
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "Thủ trưởng	",
              en: "(Boss)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontWeight: "bold",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
          {
            editable: true,
            visible: true,
            canHide: false,
            hasValue: false,
            arrangeable: false,
            order: 1,
            dataType: "string",
            style: {
              width: "5%",
            },
            valueStyle: {},
            label: {
              vi: "(Ký, ghi rõ họ tên)",
              en: "(Sign & Fullname)",
            },
            labelStyle: {
              vi: {
                fontSize: "14px",
                fontStyle: "italic",
              },
              en: {
                fontSize: "13px",
                fontStyle: "italic",
              },
            },
            numberSymbol: "1",
            numberSymbolStyle: {
              fontStyle: "italic",
            },
          },
        ],
      },
    ],
  },
  footerSection: {
    style: {
      textAlign: "center",
    },
    isSelectable: false,
    paragraph: [
      {
        text: "Tra cứu hóa đơn điện tử tại trang web: https://inv.4si.vn/tra-cuu-hoa-don. Mã số tra cứu: ",
        style: {},
      },
      {
        text: "Đơn vị cung cấp dịch vụ Hóa đơn điện tử: Công ty TNHH L.C.S – Mã số thuế: 0302999571 – Tel: 19001837",
        style: {},
      },
    ],
  },
};

export const invoiceTable = {
  1: {
    value: "1",
    label: "Hóa đơn giá trị gia tăng",
    fields: [
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "5%",
        },
        name: "stt",
        valueStyle: {},
        label: {
          vi: "STT",
          en: "(No.)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
          },
          textAlign: "center",
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(1)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        dataType: "string",
        style: {
          width: "30%",
        },
        name: "thhdvu",
        valueStyle: {},
        label: {
          vi: "Tên hàng hóa, dịch vụ",
          en: "(Description)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(2)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        dataType: "string",
        style: {
          width: "10%",
        },
        name: "dvtinh",
        valueStyle: {},
        label: {
          vi: "Đơn vị tính",
          en: "(Unit)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(3)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        dataType: "string",
        style: {
          width: "8%",
        },
        name: "sluong",
        valueStyle: {},
        label: {
          vi: "Số lượng",
          en: "(Quantity)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(4)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        dataType: "string",
        style: {
          width: "10%",
        },
        name: "dgia",
        valueStyle: {},
        label: {
          vi: "Đơn giá",
          en: "(Unit price)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        dataType: "string",
        style: {
          width: "10%",
        },
        name: "thtien",
        valueStyle: {},
        label: {
          vi: "Thành tiền",
          en: "(Amount)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(6)= (4) x (5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
    ],
    summaryFields: [
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          textAlign: "right",
        },
        colSpan: 5,
        hasValue: true,
        name: "table_total_amount",
        valueStyle: {},
        label: {
          vi: "Cộng tiền hàng",
          en: "(Total amount)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          textAlign: "right",
        },
        hasValue: true,
        colSpan: 5,
        name: "table_vat_rate",
        valueStyle: {},
        label: {
          vi: "Thuế suất GTGT",
          en: "(VAT Rate)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          textAlign: "right",
        },
        hasValue: true,
        colSpan: 5,
        valueStyle: {},
        name: "table_vat_amount",
        label: {
          vi: "Tiền thuế GTGT",
          en: "(VAT amount)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
          textAlign: "right",
        },
        hasValue: true,
        colSpan: 5,
        valueStyle: {},
        name: "table_total_payment",
        label: {
          vi: "Tổng cộng tiền thanh toán",
          en: "(Total payment)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        dataType: "string",
        visible: true,
        style: {
        },
        hasValue: false,
        colSpan: 6,
        valueStyle: {},
        name: "table_total_in_words",
        label: {
          vi: "Số tiền viết bằng chữ",
          en: "(In words)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
    ],
  },
  2: {
    value: "2",
    label: "Hóa đơn bán hàng",
    fields: [
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        style: {
          width: "5%",
        },
        name: "stt",
        valueStyle: {},
        label: {
          vi: "STT",
          en: "(No.)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
          },
          textAlign: "center",
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(1)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "30%",
        },
        name: "thhdvu",
        valueStyle: {},
        label: {
          vi: "Tên hàng hóa, dịch vụ",
          en: "(Description)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(2)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "dvtinh",
        valueStyle: {},
        label: {
          vi: "Đơn vị tính",
          en: "(Unit)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(3)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "8%",
        },
        name: "sluong",
        valueStyle: {},
        label: {
          vi: "Số lượng",
          en: "(Quantity)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(4)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "dgia",
        valueStyle: {},
        label: {
          vi: "Đơn giá",
          en: "(Unit price)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "thtien",
        valueStyle: {},
        label: {
          vi: "Thành tiền",
          en: "(Amount)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(6)= (4) x (5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
    ],
    summaryFields: [
      {
        editable: true,
        arrangeable: false,
        order: 1,
        visible: true,
        style: {
          textAlign: "right",
        },
        colSpan: 5,
        hasValue: true,
        name: "table_total_amount",
        valueStyle: {},
        label: {
          vi: "Cộng tiền hàng",
          en: "(Total amount)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
      {
        editable: true,
        arrangeable: false,
        order: 1,
        visible: true,
        style: {
          textAlign: "left",
        },
        hasValue: false,
        colSpan: 6,
        valueStyle: {},
        name: "table_total_in_words",
        label: {
          vi: "Số tiền viết bằng chữ",
          en: "(In words)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      },
    ],
  },
  3: {
    value: "6",
    label: "Phiếu xuất kho",
    fields: [
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        style: {
          width: "5%",
        },
        name: "stt",
        valueStyle: {},
        label: {
          vi: "STT",
          en: "(No.)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
          },
          textAlign: "center",
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(1)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "30%",
        },
        name: "thhdvu",
        valueStyle: {},
        label: {
          vi: "Tên hàng hóa, dịch vụ",
          en: "(Description)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(2)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "code",
        valueStyle: {},
        label: {
          vi: "Mã số",
          en: "(code)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(3)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "dvtinh",
        valueStyle: {},
        label: {
          vi: "Đơn vị tính",
          en: "(Unit)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(4)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "8%",
        },
        name: "sluong",
        valueStyle: {},
        label: {
          vi: "Thực xuất",
          en: "(Export)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(5)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "8%",
        },
        name: "sluong",
        valueStyle: {},
        label: {
          vi: "Thực nhập",
          en: "(Import)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(6)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "dgia",
        valueStyle: {},
        label: {
          vi: "Đơn giá",
          en: "(Unit price)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(7)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
      {
        editable: true,
        visible: true,
        canHide: false,
        hasValue: false,
        arrangeable: false,
        order: 1,
        style: {
          width: "10%",
        },
        name: "thtien",
        valueStyle: {},
        label: {
          vi: "Thành tiền",
          en: "(Amount)",
        },
        labelStyle: {
          vi: {
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        numberSymbol: "(8)",
        numberSymbolStyle: {
          fontStyle: "italic",
          textAlign: "center",
        },
      },
    ],
    summaryFields: [
      {
        editable: true,
        arrangeable: false,
        order: 1,
        visible: true,
        style: {
        },
        hasValue: false,
        colSpan: 8,
        name: "table_total_amount",
        valueStyle: {},
        label: {
          vi: "Tổng cộng",
          en: "(Total)",
        },
        labelStyle: {
          vi: {
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          },
          en: {
            fontSize: "13px",
            fontStyle: "italic",
            textAlign: "center",
          },
        },
        delimiterStyle: {},
        delimiter: ":",
      }
    ],
  },
};
